import React from 'react';
import styles from './defaultLoader.module.scss';

import { classnames } from '../util';

type LoaderProps = {
  size?: string;
  color?: string;
  position?: string;
  type?: string;
};

const DefaultLoader = (props: LoaderProps) => (
  <span
    className={classnames(styles.DefaultLoader, {
      [styles['block']]: props.type === 'block',
      [styles['secondary']]: props.color === 'secondary',
      [styles['white']]: props.color === 'white',
    })}
  />
);

export default DefaultLoader;
